export default __webpack_public_path__ + "static/media/cancel-icon.49760677.svg";